<template>
  <div class="container o-form-page">
    <div v-if="item.code && !!workflowInstance" class="container-fixed">
      <b-container fluid>
        <b-row>
          <b-col cols="8">
            <h1
              class="d-flex flex-row justify-content-between align-items-center mod-p"
            >
              {{ item.code }}
            </h1>
          </b-col>
          <b-col
            class="d-flex flex-row justify-content-center align-items-center"
            cols="4"
          >
            <template v-if="!!workflowInstance">
              <h2
                class="pl-2 mod-span d-flex flex-row justify-content-center align-items-center"
                :key="index"
                v-for="(detail, index) in workflowInstanceDetail"
                variant="secondary"
              >
                <b-badge
                  class="d-flex flex-row justify-content-center align-items-center"
                  >{{ detail.state__name }}</b-badge
                >
              </h2>
            </template>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div
      :class="!!workflowInstance ? 'marginTop-25' : ''"
      v-if="!currentUser.role.supervisor"
    >
      <b-alert show variant="danger"
        >User {{ currentUser.username }} cannot create a request due to no
        supervisor has been assigned to the user account. Please contact Shojun
        services.</b-alert
      >
    </div>
    <div
      :class="!!workflowInstance ? 'marginTop-25' : ''"
      v-if="
        currentUser.role.supervisor &&
        getSupervisorDetails &&
        !getSupervisorDetails.email
      "
    >
      <b-alert show variant="danger"
        >User {{ getSupervisorDetails.name }} cannot create a request due to no
        supervisor email address has been found. Please contact SHojun
        services.</b-alert
      >
    </div>
    <o-working-overlay :working="working"></o-working-overlay>
    <o-section
      :class="!!workflowInstance ? 'marginTop-25' : ''"
      :title="title"
      @click="enableDebug($event)"
      :level="0"
    >

    <!-- max-number-files-accepted="" -->
      <item-form
        :job-item="selectedJob"
        :form-state="formState"
        :item="item"
        :server-errors="serverErrors"
        
        v-bind:create="create"
      ></item-form>
    </o-section>
    <o-action-buttons
      :can-save="checkRole"
      :hide-save="getItemId"
      hide-delete
      :item="item"
      :form-state="formState"
      :create="create"
      @save="checkFiles(doSave)"
      @saveAndClose="checkFiles(doSaveAndClose)"
      @saveAndNew="checkFiles(doSaveAndNew)"
      @delete="doDeleteItem"
      :show-create-and-new="true"
    ></o-action-buttons>
  </div>
</template>

<script>
import {
  CreateFormPageMixin,
  CreateGroupPermissionMixin,
  UnsavedMixin,
  CreateCodeTableFetchMixin,
} from "../../../vue-ocom/mixins";
import ItemForm from "../components/ItemForm.vue";
import OActionButtons from "../../../vue-ocom/components/forms/OActionButtons";
import OSection from "../../../vue-ocom/components/layout/OSection";
import OWorkingOverlay from "../../../vue-ocom/components/OWorkingOverlay";
import { mapMutations, mapActions } from "vuex";
import _ from "lodash";
import { HasGroupMixin } from "../../../vue-ocom/auth/mixin/AuthFormMixins.js";

export default {
  mixins: [
    HasGroupMixin("Administrator"),
    UnsavedMixin,
    CreateFormPageMixin("ServiceRepair", "service_repair_request"),
    CreateCodeTableFetchMixin(["Process", "Supervisor"], {
      model_type: "service_repair",
      filter: "active",
      sort: "created_date",
      order: "desc",
    }),
    CreateGroupPermissionMixin("ServiceRepair"),
  ],
  components: {
    OSection,
    OWorkingOverlay,
    OActionButtons,
    ItemForm,
  },
  props: {
    create: { type: Boolean, default: false },
  },
  data() {
    return {
      selectedJob: null,
    };
  },
  methods: {
    ...mapMutations(["showMessage"]),
    ...mapActions("WorkflowInstanceModule", {
      saveWorkFLow: "saveItem",
    }),
    checkRole() {
      if (!this.currentUser.role.supervisor) {
        return false;
      }
      if (
        this.currentUser.role.supervisor &&
        this.getSupervisorDetails &&
        !this.getSupervisorDetails.email
      ) {
        return false;
      }
      return true;
    },

    checkFiles(functSave) {
      if (
        this.item.repair_files.length < 2 &&
        !this.item.engineering_required
      ) {
        this.showMessage({
          message: "Please upload atleast two (2) photos",
          type: "danger",
          show: true,
        });
        return false;
      }
      if (this.item.repair_files.length < 3 && this.item.engineering_required) {
        this.showMessage({
          message:
            "Please upload atleast three (3) photos and Includes Marked up Plan",
          type: "danger",
          show: true,
        });
        return false;
      }
      if (!this.item.description) {
        this.showMessage({
          message: "Don't forget the add description",
          type: "danger",
          show: true,
        });
        return false;
      }

      if (!this.currentUser.role.supervisor) {
        this.showMessage({
          message: `User  ${this.currentUser.username} has no supervisor account assigned. Please contact Shojun services.`,
          type: "danger",
          show: true,
        });
        return false;
      }

      const data = {
        _new: true,
        process: this.getLatestProcess,
      };
      this.saveWorkFLow(data).then((result) => {
        this.item.workflow_instance = result.id;
        functSave();
      });
    },
  },
  computed: {
    getSupervisorDetails() {
      if (this.currentUser.role.supervisor) {
        const currentSupervisor = this.optionSupervisorItems.filter(
          (item) => item.id == this.currentUser.role.supervisor
        );
        if (currentSupervisor.length > 0) {
          return currentSupervisor[0];
        }
      }

      return null;
    },
    workflowInstanceDetail() {
      let filteredState = _.filter(
        this.item.workflow_instance_details.states,
        function (state) {
          return state.is_active;
        }
      );

      let getFirstState = [];
      // if the filteredState.length > 0 then get only the first state
      if (filteredState.length > 0) {
        getFirstState.push(filteredState[0]);
        return getFirstState;
      }

      // if the filteredState is empty it means the state have a type of END so we need to determine if it is APPROVED or ONHOLD
      else if (filteredState.length <= 0) {
        const name = this.item.workflow_instance_details.workflow_status;
        // this.item.workflow_instance_details.workflow_status == "onhold"
        //   ? "On Hold"
        //   : "Approved";
        getFirstState.push({ state__name: name });
        return getFirstState;
      }

      return [];
    },
    workflowInstance() {
      return this.item.workflow_instance;
    },
    getItemId() {
      if (this.item.id) {
        return true;
      }

      return false;
    },
    getLatestProcess() {
      if (this.optionProcessItems.length > 0) {
        return this.optionProcessItems[0].id;
      }
      return null;
    },
    title() {
      if (this.create) {
        return "Create Request Repair";
      }

      return "Repair Request";
    },
  },

  created() {
    if (this.$route.query.job) {
      this.selectedJob = this.$route.query.job;
    }
  },
};
</script>
<style scoped>
.marginTop-25 {
  margin-top: 25px;
}
.mod-p {
  padding: 5px 30px 5px 30px;
}
.mod-span {
  font-size: initial;
}
.container-fixed {
  background: #3071a9;
  color: #fff;
  width: inherit;
  border: 1px #3071a9 solid;
  position: sticky;
  top: 52px;
  z-index: 1000;
  margin-top: -10px;
}
.container-fixed p {
  margin: 0;
  line-break: anywhere;
}

@media screen and (max-width: 640px) {
  .action-buttons {
    margin-bottom: 20px;
  }

  .action-buttons div button {
    margin-bottom: 1px !important;
  }
}
</style>
